import { Button, Tooltip } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import { useIntl } from "react-intl";
import { toastClick } from "../../composants/toast/CustomToast";

export function Active({ path, status, id }) {
    const { accessToken, droits } = useSelector(state => state.authUser);
    const [loading, setLoading] = useState(false);
    const intL = useIntl();
    const returnValue = status ? (
        <i aria-hidden="true"><FontAwesomeIcon icon={faEye} /></i>
    ) : (
        <i aria-hidden="true"><FontAwesomeIcon icon={faEyeSlash} /></i>
    );

    const onChange = async () => {
        setLoading(true);
        await axiosInstance(accessToken).put(
            path + id
        ).then((result) => {
            toastClick(intL.formatMessage({ id: 'success' }), "success")
            setLoading(false);
            window.location.reload(true);
        }).catch((result) => {
            toastClick(result.response.data.message, 'error')
            setLoading(false);
        });
    }
    return (
        <>
            <Tooltip title={status ? intL.formatMessage({ id: 'enable' }) : intL.formatMessage({ id: 'disable' })}>
                <Button disabled={loading} loading={loading} type="default" shape="circle" onClick={onChange} title={status ? intL.formatMessage({ id: 'disable' }) : intL.formatMessage({ id: 'enable' })} >
                    {returnValue}
                </Button>
            </Tooltip>

        </>
    )
}